import { FieldInstance, FieldTemplate } from "db/definitions";
import { bulkSaveFieldInstances } from "../db/queries/fieldInstanceQueries";
import batchCreateFieldInstances from "./batchCreateFieldInstances";
import batchCreateImages from "./batchCreateImages";
import buildTableFieldsObjects from "./buildTableFieldsObjects";
import { handleBatchCrud } from "./handleBatchCrud";
import { bulkSaveImageDocs } from "db/queries/imageQueries";

/**
 * Builds one table row and creates on the db
 * @param parentFieldInstance to create the new row from
 * @param headerMap containing all templates in row
 * @param online Whether or not the user is online
 * @param projectId The id of the project containing these documents
 * @returns array of packaged field instances
 */
async function buildTableRow(
	parentFieldInstance: FieldInstance,
	headerMap: Record<string, FieldTemplate>,
	online: boolean,
	projectId: string,
	linkedAltIds?: Record<string, string>,
	linkedData?: Record<string, FieldInstance>,
): Promise<FieldInstance[]> {
	const fieldsObj = await buildTableFieldsObjects(parentFieldInstance, headerMap, online, projectId, linkedAltIds, linkedData);
	const fieldInstances = fieldsObj.fieldArray;
	const images = fieldsObj.images;
	if (online) {
		await Promise.all([handleBatchCrud(fieldInstances, batchCreateFieldInstances, 25), handleBatchCrud(images, batchCreateImages, 25)]);
	} else {
		await Promise.all([bulkSaveFieldInstances(fieldInstances), bulkSaveImageDocs(images)]);
	}
	return fieldsObj.fullFieldArray;
}

export default buildTableRow;
